module.exports = __webpack_public_path__ + "img/AlekInsta_Final.c067cc91.jpg";